import { useQuery } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/client";
import type { OnboardingStatus } from "@/api/types";
import { isErrorEnvelope } from "@/lib/handle-form-error";

export function onboardingStatusOptions(businessId?: string | null) {
  return {
    queryKey: businessId ? ["onboarding-status", businessId] : ["onboarding-status"],
    queryFn: () =>
      api
        .get("onboarding/status", { searchParams: businessId ? { business_id: businessId } : {} })
        .json<OnboardingStatus>(),
    staleTime: 30_000,
  };
}

export function useOnboardingStatus(businessId?: string | null) {
  return useQuery(onboardingStatusOptions(businessId));
}

export function isUnavailableOnboardingSelection(error: unknown): boolean {
  return (
    error instanceof HTTPError &&
    error.response.status === 404 &&
    isErrorEnvelope(error.data) &&
    error.data.errors.some((entry) => entry.code === "not_found")
  );
}
